export default (ms: number = 1000) =>
  new Promise((resolve: Function) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
